var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"share-button",attrs:{"href":"#","title":_vm.$gettext('Partager')},on:{"click":function($event){$event.preventDefault();return _vm.share.apply(null, arguments)}}},[_c('fa-icon',{attrs:{"icon":"share-alt"}}),_vm._v(" "),(_vm.copied)?_c('span',{staticClass:"copied-toast"},[_vm._v(_vm._s(_vm.$gettext('Lien copié')))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }